/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ConfigItem } from './ConfigItem';
import {
    ConfigItemFromJSON,
    ConfigItemFromJSONTyped,
    ConfigItemToJSON,
} from './ConfigItem';
import type { PartialParentRole } from './PartialParentRole';
import {
    PartialParentRoleFromJSON,
    PartialParentRoleFromJSONTyped,
    PartialParentRoleToJSON,
} from './PartialParentRole';
import type { PartialRole } from './PartialRole';
import {
    PartialRoleFromJSON,
    PartialRoleFromJSONTyped,
    PartialRoleToJSON,
} from './PartialRole';

/**
 * 
 * @export
 * @interface UpdateRoleRequest
 */
export interface UpdateRoleRequest {
    /**
     * 
     * @type {Array<PartialParentRole>}
     * @memberof UpdateRoleRequest
     */
    parentRoles: Array<PartialParentRole>;
    /**
     * 
     * @type {Array<ConfigItem>}
     * @memberof UpdateRoleRequest
     */
    configItems?: Array<ConfigItem>;
    /**
     * 
     * @type {number}
     * @memberof UpdateRoleRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleRequest
     */
    notes?: string;
}

/**
 * Check if a given object implements the UpdateRoleRequest interface.
 */
export function instanceOfUpdateRoleRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "parentRoles" in value;

    return isInstance;
}

export function UpdateRoleRequestFromJSON(json: any): UpdateRoleRequest {
    return UpdateRoleRequestFromJSONTyped(json, false);
}

export function UpdateRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRoleRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parentRoles': ((json['parentRoles'] as Array<any>).map(PartialParentRoleFromJSON)),
        'configItems': !exists(json, 'configItems') ? undefined : ((json['configItems'] as Array<any>).map(ConfigItemFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function UpdateRoleRequestToJSON(value?: UpdateRoleRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parentRoles': ((value.parentRoles as Array<any>).map(PartialParentRoleToJSON)),
        'configItems': value.configItems === undefined ? undefined : ((value.configItems as Array<any>).map(ConfigItemToJSON)),
        'id': value.id,
        'name': value.name,
        'notes': value.notes,
    };
}

